module.exports = __webpack_public_path__ + "img/backgroundThird.72d30ce9.png";